'use client'

import React, { useEffect, useState } from 'react'
import MainSlider from './MainSlider'
import { birdsChapterList, cowsChapterList, pigsChapterList } from '@/assets/data/slider-chapters'
import settings from '@/assets/data/main-catalog-settings.json'

const chapters = [
    {
        text: 'Птицеводство',
        list: birdsChapterList
    },
    {
        text: 'Животноводство',
        list: cowsChapterList
    },
    {
        text: 'Свиноводство',
        list: pigsChapterList
    }
]

const MainSliderChapters = ({ list, zIndex }: { list?: any, zIndex?: number }) => { //!FIX 
    const [currentChapter, setCurrentChapter] = useState<number | undefined>(undefined)
    const [currentList, setCurrentList] = useState(cowsChapterList)

    const changeChapter = (chapter, list) => {
        setCurrentChapter(chapter)
        setCurrentList(list)
    }

    useEffect(() => { // fix
        if (list && list.length > 0) {
            if (currentChapter === undefined) {
                let newArr = []
                list?.map((el) => {
                    newArr.push(...el.animal_types_category?.map((e) => { return e }))
                })
                setCurrentList(newArr)
                
            }
            else {
                setCurrentList(list[currentChapter]?.animal_types_category)
                
            }
        }
    }, [list])

    return (
        <>
            <ul className='slider__chapters container' style={zIndex ? {position: "relative", zIndex: zIndex} : {}}>
                {list && list.length > 1 && list.length ?
                    list?.map((chapter, index) => ( //FIX
                        <>
                            {chapter && chapter?.animal_types_category && chapter?.animal_types_category?.length > 0 ? 
                                <li
                                onClick={() => changeChapter(index, chapter.animal_types_category)}
                                className={`slider__chapters-item 
                                ${index === currentChapter && 'slider__chapters-item_selected'}`}
                                key={index}
                                >
                                    {chapter.title}
                                </li>
                            : null}
                        </>
                    ))
                    :
                    chapters?.map((chapter, index) => (
                        <li
                            onClick={() => changeChapter(index, chapter.list)}
                            className={`slider__chapters-item 
                            ${index === currentChapter && 'slider__chapters-item_selected'}`}
                            key={index}
                        >
                            {chapter.text}
                        </li>
                    ))
                }
            </ul>
            <MainSlider
                zIndex={zIndex ? zIndex : undefined}
                linkedCards={true}
                type='catalog'
                list={currentList}
                settings={settings}
            />
        </>
    )
}

export default MainSliderChapters
